export const dateFormatter = (date: string) => {
  const dateObject = new Date(date);
  return dateObject.toLocaleString('en-US');
};

export const formatDateShort = (value: unknown, locale: string): string => {
  if (typeof value !== 'string' || !value) return '';
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? value : date.toLocaleDateString(locale);
};
